import {
  SimpleForm,
  ReferenceInput,
  SelectInput,
  TextInput,
  ImageInput,
  ImageField,
  LongTextInput,
  DateInput,
  FileInput,
  FileField,
  TabbedForm,
  FormTab
} from "react-admin";
import React from "react";
import { required } from "../../services/validate";
import { SUPERADMIN } from "../../constant/TypeRole";

const AnnounceForm = props => {
  const { record } = props;
  const { permissions } = props;
  const project = JSON.parse(localStorage.getItem("project"));
  const filter = permissions
    ? permissions === SUPERADMIN
      ? {}
      : { project }
    : {};
  return (
    <TabbedForm {...props}>
      <FormTab label="announce.tab.title">
        <TextInput source="title" label="หัวข้อภาษาไทย" validate={[required()]} />
        <TextInput source="title_en" label="หัวข้อภาษาอังกฤษ" validate={[required()]} />
        <TextInput source="title_jp" label="หัวข้อภาษาญี่ปุ่น" validate={[required()]} />
        <TextInput source="title_zh" label="หัวข้อภาษาจีน" validate={[required()]} />
      </FormTab>

      <FormTab label="announce.tab.description">
        <LongTextInput source="description" label="รายละเอียดภาษาไทย" validate={[required()]} />
        <LongTextInput source="description_en" label="รายละเอียดภาษาอังกฤษ" validate={[required()]} />
        <LongTextInput source="description_jp" label="รายละเอียดภาษาญี่ปุ่น" validate={[required()]} />
        <LongTextInput source="description_zh" label="รายละเอียดภาษาจีน" validate={[required()]} />
      </FormTab>

      <FormTab label="announce.tab.other">
        <ReferenceInput
          disabled={record.project ? true : false}
          validate={[required()]}
          source="project"
          reference="project"
          filter={filter}
        >
          <SelectInput optionText="name" />
        </ReferenceInput>

        <FileInput
          validate={[required()]}
          source="file" label="ไฟล์/รูป" multiple={false} accept="image/jpeg,image/gif,image/png,application/pdf">
          <FileField target="_blank" source="url" title="ไฟล์/รูป" />
        </FileInput>

        {/* <ImageInput
        multiple={false}
        validate={[required()]}
        source="image"
        accept="image/*"
      >
        <ImageField source="url" title="title" />
      </ImageInput> */}
        <DateInput source="expire" validate={[required()]} />
      </FormTab>
    </TabbedForm>
  );
};

export default AnnounceForm;



// WEBPACK FOOTER //
// ./src/components/announce/AnnounceForm.js